(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-diy-submission"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => document.querySelectorAll('.yc-diy-submit__form').forEach(form => {
    if (form.dataset.diyReady) return;
    form.dataset.diyReady = 'true';
    const video = form.querySelector('[data-diy-video]');
    const platform = form.querySelector('[data-diy-platform]');
    if (!video || !platform) return;
    const validate = () => {
      video.setCustomValidity('');
      if (!video.value || !platform.value) return;
      try {
        const url = new URL(video.value.trim());
        const h = url.hostname.toLowerCase();
        const isHost = name => h === name || h.endsWith('.' + name);
        const allowed = platform.value === 'instagram' ? isHost('instagram.com') : isHost('facebook.com') || isHost('fb.watch');
        if (!allowed || !['https:', 'http:'].includes(url.protocol) || url.pathname === '/') video.setCustomValidity(video.dataset.urlError);
      } catch { video.setCustomValidity(video.dataset.urlError); }
    };
    video.addEventListener('input', validate);
    platform.addEventListener('change', validate);
    form.addEventListener('submit', event => {
      validate();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
    });
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-mystery-box-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yc-mystery-section]').forEach((section) => {
    const dialog = section.querySelector('[data-yc-mystery-dialog]');
    const image = dialog?.querySelector('img');
    section.querySelectorAll('[data-yc-mystery-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog || !image) return;
        image.src = button.dataset.src || '';
        image.alt = button.dataset.alt || '';
        dialog.showModal();
      });
    });
    section.querySelector('[data-yc-mystery-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
